import { UncontrolledNumberInputField } from '@mews-commander/form';
import { SimpleList, SimpleListItem, Stack, Typography } from '@optimus-web/core';
import { lt } from '@mews/framework';
import { GeneralPaymentConfiguration } from '@mews-commander/data-access';
import { PaymentsConfigurationFieldName } from '../../types';
import { CardSharingCheckbox } from './CardSharingCheckbox';
import { CardSharingDisabledBanner } from './CardSharingDisabledBanner';

type Props = Pick<GeneralPaymentConfiguration, 'enterprises' | 'isAdminInAllEnterprisesInChain'>;

export const PaymentsConfigurationFormFields = ({ enterprises, isAdminInAllEnterprisesInChain }: Props) => {
    const enterpriseList = (
        <SimpleList spacing="200">
            {enterprises.map(({ id, name }) => (
                <SimpleListItem key={id}>
                    <Typography textStyle="bodyLarge" as="div">
                        {' '}
                        {name}{' '}
                    </Typography>
                </SimpleListItem>
            ))}
        </SimpleList>
    );

    return (
        <Stack vertical spacing="300">
            <Typography textStyle="titleMediumStrong" as="div">
                {lt('PaymentsConfigurationFormTitle')}
            </Typography>
            <Typography textStyle="titleSmallStrong" as="div">
                {lt('PaymentsConfigurationRetentionPolicyTitle')}
            </Typography>
            <UncontrolledNumberInputField
                helper={lt('PaymentsConfigurationRetentionPolicyInputHelper')}
                label={lt('PaymentsConfigurationRetentionPolicyInputLabel')}
                name={PaymentsConfigurationFieldName.RetentionPolicyDays}
                required
                suffix={lt('DayPlural')}
                type="number"
            />
            {enterprises.length > 1 && (
                <>
                    <Typography textStyle="titleSmallStrong" as="div">
                        {lt('PaymentsConfigurationCardSharingTitle')}
                    </Typography>
                    {isAdminInAllEnterprisesInChain ? (
                        <CardSharingCheckbox>{enterpriseList}</CardSharingCheckbox>
                    ) : (
                        <CardSharingDisabledBanner>{enterpriseList}</CardSharingDisabledBanner>
                    )}
                </>
            )}
        </Stack>
    );
};
